import data from './config.json';
export const config = data;
